import { render } from "./LiftTableActions.vue?vue&type=template&id=5cd1a012"
import script from "./LiftTableActions.vue?vue&type=script&lang=js"
export * from "./LiftTableActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__